import React from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  Typography,
  Stack,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const VARIANTS = {
  error: {
    Icon: ErrorOutlineIcon,
    color: 'error.main',
    title: 'Erro',
    btnColor: 'error',
  },
  success: {
    Icon: CheckCircleOutlineIcon,
    color: 'success.main',
    title: 'Sucesso',
    btnColor: 'success',
  },
  warning: {
    Icon: WarningAmberIcon,
    color: 'warning.main',
    title: 'Atenção',
    btnColor: 'warning',
  },
};

export default function CenteredAlert({
  open,
  variant = 'error',
  title,
  message,
  onClose,
}) {
  if (!open || !message) return null;

  const cfg = VARIANTS[variant] || VARIANTS.error;
  const Icon = cfg.Icon;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      slotProps={{
        backdrop: { sx: { bgcolor: 'rgba(0,0,0,0.5)' } },
      }}
      PaperProps={{ sx: { borderRadius: 3 } }}
      sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
    >
      <DialogContent>
        <Stack alignItems="center" textAlign="center" spacing={2} sx={{ py: 2 }}>
          <Icon sx={{ fontSize: 48, color: cfg.color }} />
          <Typography variant="h6" fontWeight={800}>
            {title || cfg.title}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ whiteSpace: 'pre-line' }}
          >
            {message}
          </Typography>
          <Button
            variant="contained"
            color={cfg.btnColor}
            onClick={onClose}
            sx={{ mt: 1, minWidth: 120, fontWeight: 700 }}
          >
            OK
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
